"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalListener = exports.platform = void 0;
var EventEmitter_1 = require("./EventEmitter");
var browser_1 = require("../platform/getFetch/browser");
var browser_2 = require("../platform/getEventSource/browser");
var browser_3 = require("@splitsoftware/splitio-commons/cjs/listeners/browser");
var browser_4 = require("@splitsoftware/splitio-commons/cjs/utils/timeTracker/now/browser");
exports.platform = {
    getFetch: browser_1.getFetch,
    getEventSource: browser_2.getEventSource,
    EventEmitter: EventEmitter_1.EventEmitter,
    now: browser_4.now
};
exports.SignalListener = browser_3.BrowserSignalListener;
